export default {
	warning: false,
	error: false,
	small: false,
	label: "",
};
